var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { BalanceContext } from "../balance";
import { ClientWalletContext } from "@/features/wallet/context-api/providers/client-wallet";
var getChargedBackTransactions = function (transactions) {
    return transactions.reduce(function (hashs, transaction) {
        var _a;
        if (transaction.parentHash) {
            return __assign(__assign({}, hashs), (_a = {}, _a[transaction.parentHash] = true, _a));
        }
        return hashs;
    }, {});
};
export var TransactionsContext = React.createContext({
    loading: true,
    transactions: [],
    chargebackTransaction: function () { return Promise.resolve(null); },
    loadTransactions: function () { return null; },
    updateDateRange: function () { return null; },
});
export var TransactionsProvider = function (_a) {
    var children = _a.children, walletDatasource = _a.walletDatasource, clientWalletId = _a.clientWalletId;
    var clientWallet = useContext(ClientWalletContext).clientWallet;
    var authWalletId = clientWallet === null || clientWallet === void 0 ? void 0 : clientWallet.walletUuid;
    var refreshBalance = useContext(BalanceContext).refresh;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), transactions = _c[0], setTransactions = _c[1];
    var _d = useState(), metadata = _d[0], setMetadata = _d[1];
    var _e = useState(), dateRange = _e[0], setDateRange = _e[1];
    var walletId = useMemo(function () {
        return clientWalletId || authWalletId;
    }, [clientWallet]);
    var requestTransactions = function (meta, dateRange) {
        setLoading(true);
        walletDatasource
            .getTransactions(walletId, { page: (meta === null || meta === void 0 ? void 0 : meta.page) || 1, limit: 10 }, dateRange)
            .then(function (_a) {
            var meta = _a.meta, data = _a.data;
            var chargedback = getChargedBackTransactions(data);
            setTransactions(data.map(function (transaction) { return (__assign(__assign({}, transaction), { chargedback: chargedback[transaction.hash] })); }));
            setMetadata(__assign({}, meta));
        })
            .finally(function () { return setLoading(false); });
    };
    useEffect(function () {
        if (!walletId)
            return;
        requestTransactions(metadata, dateRange);
    }, [walletId]);
    var loadTransactions = function (page) {
        setMetadata(function (meta) { return (__assign(__assign({}, meta), { page: page })); });
        requestTransactions(__assign(__assign({}, metadata), { page: page }), dateRange);
    };
    var updateDateRange = function (range) {
        setDateRange(range);
        setMetadata(function (meta) { return (__assign(__assign({}, meta), { page: 1 })); });
        requestTransactions(__assign(__assign({}, metadata), { page: 1 }), range);
    };
    var chargebackTransaction = function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
        var res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, walletDatasource.chargebackCreditPurchase({
                            transactionHash: transaction.hash,
                            description: "Chargeback of transaction #" + transaction.id,
                        })];
                case 1:
                    res = _a.sent();
                    requestTransactions(metadata, dateRange);
                    refreshBalance();
                    return [2 /*return*/, res];
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(TransactionsContext.Provider, { value: {
            chargebackTransaction: chargebackTransaction,
            loading: loading,
            transactions: transactions,
            metadata: metadata,
            loadTransactions: loadTransactions,
            updateDateRange: updateDateRange,
        } }, children));
};
